import axiosInstanceBuilder from "../axiosInstance"
const axiosInstance = axiosInstanceBuilder('api')

export const getAllTicket = (params: any) => {
  return axiosInstance.get('/tickets', {
    params
  })
}
export const getTicketFilter = (params: any) => {
  return axiosInstance.get('/tickets/filter', {
    params
  })
}

export const getSingleTicket = (id: string) => {
  return axiosInstance.get(`/tickets/${id}`)
}

export const getTicketContents = (id: string) => {
  return axiosInstance.get(`/tickets/${id}/content`)
}

export const getStatusCounts = () => {
  return axiosInstance.get(`/tickets/count`)
}

export const getCategories = (params: any) => {
  return axiosInstance.get('/categories', {
    params
  })
}
export const getSubjects = (params: any) => {
  return axiosInstance.get('/subjects', {
    params
  })
}

export const downloadFile = (id: number, ticketId: string, name: string) => {
  return fetch(`${axiosInstance.defaults.baseURL}/tickets/${ticketId}/content/${id}/file`, {
    headers: {
      authorization: 'Bearer ' + localStorage.getItem('token')
    }
  })
}